import React from 'react'
import { Typography } from '@material-ui/core';
export default class LinkButton extends React.Component{
    constructor(props){
        super(props)
    }
    gotPage=()=>{
        window.location.href=this.props.url;
        document.title=this.props.text;
        // window.location.replace(this.props.url);
        // window.history.pushState(null,this.props.text,this.props.url)
    }
    render(){
        return <Typography variant='subtitle2'  onClick={this.gotPage} style={{cursor:'pointer'}}>
                {this.props.text}
               </Typography>
    }
} 